module.exports = require('./dist/index');


//////////////////
// WEBPACK FOOTER
// ./~/react-spinners/index.js
// module id = 15
// module chunks = 4